import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useFeedbackList(query: Record<string, string> = {}) {
  return useQuery({
    queryKey: ['feedback', query],
    queryFn: () => apiClient.listFeedback(query),
  });
}

export function useCreateFeedback() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { type: string; title: string; description: string }) =>
      apiClient.createFeedback(data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['feedback'] }); },
  });
}

export function useAdminFeedbackList(query: Record<string, string> = {}) {
  return useQuery({
    queryKey: ['admin-feedback', query],
    queryFn: () => apiClient.adminListFeedback(query),
  });
}

export function useAdminFeedbackStats() {
  return useQuery({
    queryKey: ['admin-feedback-stats'],
    queryFn: () => apiClient.adminFeedbackStats(),
  });
}

export function useAdminUpdateFeedbackStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: string }) =>
      apiClient.adminUpdateFeedbackStatus(id, status),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin-feedback'] });
      qc.invalidateQueries({ queryKey: ['admin-feedback-stats'] });
    },
  });
}

export function useAdminReplyFeedback() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reply }: { id: string; reply: string }) =>
      apiClient.adminReplyFeedback(id, reply),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin-feedback'] });
      qc.invalidateQueries({ queryKey: ['admin-feedback-stats'] });
    },
  });
}
